import { IPageComponent } from '@/types/iPageComponent.interface';
import { Type } from '@angular/core';

export type PageLoader = () => Promise<Type<IPageComponent>>;

export const RouteRegistry: Record<string, PageLoader> = {
  "/presensi/request": () =>
    import('../pages/presensi/request/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/presensi/report": () =>
    import('../pages/presensi/report/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/presensi/settings": () =>
    import('../pages/presensi/settings/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/presensi/wfh-wfo-settings": () =>
    import('../pages/presensi/wfh-wfo-settings/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/leave/request": () =>
    import('../pages/leave/request/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/leave/approval": () =>
    import('../pages/leave/approval/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/leave/settings": () =>
    import('../pages/leave/settings/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>),

  "/leave/history": () =>
    import('../pages/leave/history/page.component')
      .then(m => m.PageComponent as Type<IPageComponent>)


  // "/leave/report": () =>
  //   import('../pages/leave/report/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/reimburse/request": () =>
  //   import('../pages/reimburse/request/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/reimburse/approval": () =>
  //   import('../pages/reimburse/approval/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/biztrip/create": () =>
  //   import('../pages/biztrip/create/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/biztrip/request": () =>
  //   import('../pages/biztrip/request/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/biztrip/approval": () =>
  //   import('../pages/biztrip/approval/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/biztrip/expense": () =>
  //   import('../pages/biztrip/expense/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // =========================
  // SETTINGS (SYSTEM)
  // =========================
  // "/settings/users": () =>
  //   import('../pages/settings/users/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),

  // "/settings/roles": () =>
  //   import('../pages/settings/roles/page.component')
  //     .then(m => m.PageComponent as Type<IPageComponent>),
};
